import React, { useContext, useEffect, useState } from "react";
import WalletLogin from "./wallet-auth/WalletLogin";
import { Web3Provider } from "/context/Web3Provider";
import useForm from "/utils/hooks/useForm";
import CustomButton from "/components/core/ButtonDefault";
import FormLabels from "/components/core/labels/Form";
import AuthContext from "/context/AuthProvider";
import { useTranslation } from "react-i18next";
import { useUserCache } from "/utils/hooks/useUserCache";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import SocialButtonsGrid from "./Registration/SocialButtonsGrid";
import { useSSO } from "/utils/hooks/useSSO";

export default function Login({ state, defaultError }) {
  const isWalletConnectActive = useFeatureIsOn("can-use-auth-with-wallet");
  const isSocialLoginEnabled = useFeatureIsOn("social-register");
  const useform = useForm({}, "auth/login");
  const { isSuccess, isSending, formResponse, setInvalidFields, handleSubmit } =
    useform;
  const { setAuth } = useContext(AuthContext);
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  const { wipe } = useUserCache();

  const [currentProvider, setCurrentProvider] = useState("");
  const { error: ssoError1, loading: ssoLoading, signIn } = useSSO();

  const ssoError = ssoError1 ?? defaultError;

  const labels = [
    {
      placeholder: t("registration.labels.email.placeholder"),
      type: "email",
      name: "email",
      spaces: true,
    },
    {
      placeholder: t("registration.labels.password.placeholder"),
      type: "password",
      name: "password",
    },
    {
      title: t("labels.rememberMe", { defaultValue: "Remember me" }),
      type: "checkbox",
      name: "remember",
    },
  ];

  useEffect(() => {
    if (!isSuccess) return;
    setAuth({ ...formResponse });
    state.setPopUp("");
    return () => {};
  }, [isSuccess]);

  useEffect(() => {
    const err = formResponse?.errors;

    if (err && Array.isArray(err)) {
      setInvalidFields((e) => ({ ...e, email: err[0] }));
    } else {
      const s = formResponse?.success;
      const m = formResponse?.message;
      !s && m && setError(m);
    }
    return () => {};
  }, [formResponse]);

  const performSubmit = (e) => {
    e.preventDefault();
    wipe();
    return handleSubmit(e);
  };

  return (
    <>
      <div className="title">
        <p className="t fixel_36">
          {t("labels.signIn", { defaultValue: "Sign In" })}
        </p>
      </div>

      <div className="content_data df fd-c ai-c">
        {isSocialLoginEnabled ? (
          <SocialButtonsGrid
            displayContext="login"
            disabled={ssoLoading}
            selected={currentProvider}
            onSelect={async (provider) => {
              setCurrentProvider(provider);
              await signIn(provider);
            }}
          >
            {ssoError && (
              <div className="text-center color-red">{ssoError.message}</div>
            )}
          </SocialButtonsGrid>
        ) : null}
        {/* {isGoogleAuthActive && <GoogleLogin />} */}
        {isWalletConnectActive && (
          <Web3Provider>
            <WalletLogin />
          </Web3Provider>
        )}
        {isWalletConnectActive && (
          <div className="or df ai-c fixel_16_sbl">
            {t("labels.or", { defaultValue: "OR" })}
          </div>
        )}

        <form className="form df fd-c" onSubmit={performSubmit}>
          <div className="form_content">
            {error && (
              <p className="fixel_22 text-center color-red w-full">{error}</p>
            )}
            <FormLabels
              {...useform}
              labels={labels}
              selectData={null}
              def={null}
            />

            <button
              type="button"
              className="def wt"
              onClick={(e) => state.setPopUp("reset")}
            >
              {t("message.forgotPassword")}
            </button>
          </div>
          <CustomButton
            classname="submit pr as-c"
            def={40}
            type="submit"
            title={t("labels.signIn", { defaultValue: "Sign In" })}
            disabled={isSending}
            onClick={() => {}}
          />
        </form>
      </div>
      <div className="switch_form jc-c fw as-c df">
        <p className="fixel_16_sbl">
          {t("registration.notMember", { defaultValue: "Not a member?" })}
        </p>
        <button className="def wt promo" onClick={() => state.setPopUp("reg")}>
          {t("layout.header.register")}
        </button>
      </div>
    </>
  );
}
